module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-grid-feature-01-b109a0bc2d4556feb03b7a7c00bee15b.jpg";